import getConfig from 'next/config';
import {Tenant} from '~/src/utilities/constants/tenant';

const {publicRuntimeConfig: config} = getConfig();

const prefix = config.tenantId === Tenant.LEMATIN ? 'lematin' : '20min';

/**
 * Cookie constants
 */
const Cookie = {
    SESSION: `${prefix}-Session`,
    GA: '_ga',
    LANGUAGE: `${prefix}-Language`,
    APP_CID: `${prefix}-app-cid`
};

export {Cookie};
